'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMessage = exports.addMessage = exports.bulkAddMessages = exports.containsMessage = exports.setStatus = exports.setEndTime = exports.setStartTime = exports.sortHistory = exports.setLatestMessage = exports.getLatestMessage = exports.getMessagesInHistory = exports.KEY_PATHS = undefined;
exports.isStarted = isStarted;
exports.isBlocked = isBlocked;
exports.canCloseConversation = canCloseConversation;
exports.hasSentMessages = hasSentMessages;

var _immutable = require('immutable');

var _transmute = require('transmute');

var _ChatFilterOptions = require('conversations-schema/constants/ChatFilterOptions');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _PubNubMessageGroups = require('conversations-schema/constants/PubNubMessageGroups');

var _PubNubMessageGroups2 = _interopRequireDefault(_PubNubMessageGroups);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY_PATHS = exports.KEY_PATHS = {
  LATEST_MESSAGE: ['latestMessage'],
  MESSAGES_HISTORY: ['chatHistory', 'history'],
  START_TIME: ['chatHistory', 'startTime'],
  END_TIME: ['chatHistory', 'endTime'],
  UNSEEN_COUNT: ['unseenCount'],
  STATUS: ['status']
};

var getMessagesInHistory = exports.getMessagesInHistory = (0, _transmute.getIn)(KEY_PATHS.MESSAGES_HISTORY);

var getLatestMessage = exports.getLatestMessage = function getLatestMessage(conversation) {
  var latestMessageFromHistory = (0, _transmute.pipe)(getMessagesInHistory, (0, _transmute.filter)(_ConversationalMessageModel.isChatMessage), function (chatMessages) {
    return chatMessages.last();
  })(conversation);

  return latestMessageFromHistory || conversation.getIn(KEY_PATHS.LATEST_MESSAGE);
};

var setLatestMessage = exports.setLatestMessage = function setLatestMessage(conversation) {
  return conversation.setIn(KEY_PATHS.LATEST_MESSAGE, getLatestMessage(conversation));
};

var sortHistory = exports.sortHistory = function sortHistory(conversation) {
  return conversation.updateIn(KEY_PATHS.MESSAGES_HISTORY, (0, _transmute.pipe)((0, _transmute.sortBy)(_PubNubMessageModel.getTimestamp), function (history) {
    return history.groupBy(_PubNubMessageModel.getMessageGroup);
  }, function (groupedHistory) {
    var history = groupedHistory.get(_PubNubMessageGroups2.default.HISTORY, (0, _immutable.OrderedSet)());
    var publishing = groupedHistory.get(_PubNubMessageGroups2.default.PUBLISHING, (0, _immutable.OrderedSet)());

    return history.concat(publishing);
  }));
};

var setStartTime = exports.setStartTime = (0, _transmute.curry)(function (startTime, conversation) {
  return conversation.setIn(KEY_PATHS.START_TIME, startTime);
});

var setEndTime = exports.setEndTime = (0, _transmute.curry)(function (endTime, conversation) {
  return conversation.setIn(KEY_PATHS.END_TIME, endTime);
});

var setStatus = exports.setStatus = (0, _transmute.curry)(function (status, conversation) {
  return conversation.setIn(KEY_PATHS.STATUS, status);
});

var containsMessage = exports.containsMessage = (0, _transmute.curry)(function (conversation, message) {
  return conversation.update((0, _transmute.pipe)(getMessagesInHistory, function (messages) {
    return messages.find((0, _PubNubMessageModel.isEqual)(message));
  }, function (matchedMessage) {
    return Boolean(matchedMessage);
  }));
});

var bulkAddMessages = exports.bulkAddMessages = (0, _transmute.curry)(function (messages, conversation) {
  var messagesToAdd = messages.filterNot(containsMessage(conversation));

  if (!messagesToAdd.size) return conversation;

  return conversation.update((0, _transmute.pipe)((0, _transmute.updateIn)(KEY_PATHS.MESSAGES_HISTORY, function (history) {
    return history.concat(messagesToAdd);
  }), sortHistory));
});

var addMessage = exports.addMessage = (0, _transmute.curry)(function (message, conversation) {
  return bulkAddMessages((0, _immutable.List)([message]), conversation);
});

var updateMessage = exports.updateMessage = (0, _transmute.curry)(function (message, updatedMessage, conversation) {
  return conversation.update((0, _transmute.pipe)((0, _transmute.updateIn)(KEY_PATHS.MESSAGES_HISTORY, function (history) {
    var messagesList = history.toList();
    var matching = messagesList.find((0, _PubNubMessageModel.isEqual)(message));
    var index = messagesList.indexOf(matching);
    return messagesList.set(index, updatedMessage).toOrderedSet();
  }), sortHistory));
});

function isStarted(conversation) {
  return conversation.status === _ChatFilterOptions.STARTED;
}

function isBlocked(conversation) {
  if (!conversation) {
    return false;
  }
  return conversation.status === _ChatFilterOptions.BLOCKED;
}

function canCloseConversation(conversation) {
  if (!conversation) {
    return false;
  }

  var status = conversation.status;


  return status !== _ChatFilterOptions.BLOCKED && status !== _ChatFilterOptions.ENDED;
}

function hasSentMessages(conversation) {
  var history = getMessagesInHistory(conversation);
  if (!history) {
    return false;
  }

  return history.size > 1;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/models/ConversationModel.js
// module id = 52
// module chunks = 0 1